module.exports = __webpack_public_path__ + "img/t4-salmon.a086571f.png";